/* BLT shared scroll-lock helper.
   iOS Safari ignores `overflow:hidden` on <html>/<body>, so every overlay/drawer
   that relied on it let the page rubber-band/scroll behind the overlay. This locks
   the background reliably by pinning <body> with position:fixed at the saved scroll
   offset, and restores the exact scroll position on unlock.

   Ref-counted so stacked overlays (e.g. cart opening over an already-open page)
   don't unlock the background until the LAST one closes.

   Usage (loader is `defer`, so window.BltScrollLock exists by the time any user
   interaction opens a drawer):
     BltScrollLock.lock();    // on open
     BltScrollLock.unlock();  // on close
*/
(function () {
  if (window.BltScrollLock) return;

  var locks = 0;
  var savedY = 0;

  function lock() {
    if (locks++ > 0) return; // already locked by another overlay
    savedY = window.scrollY || window.pageYOffset || 0;
    var b = document.body;
    b.style.position = 'fixed';
    b.style.top = -savedY + 'px';
    b.style.left = '0';
    b.style.right = '0';
    b.style.width = '100%';
    document.documentElement.classList.add('blt-scroll-locked');
  }

  function unlock() {
    if (locks === 0) return;
    if (--locks > 0) return; // another overlay still open
    var b = document.body;
    b.style.position = '';
    b.style.top = '';
    b.style.left = '';
    b.style.right = '';
    b.style.width = '';
    document.documentElement.classList.remove('blt-scroll-locked');
    window.scrollTo(0, savedY);
  }

  window.BltScrollLock = { lock: lock, unlock: unlock };
})();
